// Referrer module

export const referrerGet = ({ code, uri, success, fail, complete, progress }) => {
    console.debug('Referrer Get');
    const data = new FormData();
    const xhr = new XMLHttpRequest();
    uri += code;
    xhr.responseType = "json";
    xhr.open("GET", uri, true);
    xhr.addEventListener("load", () => {
        console.debug("Referrer search request successful");
        if(success) success(xhr.response);
    });
    xhr.addEventListener("error", () => {
        if(fail) fail(xhr);
    });
    xhr.addEventListener("progress", (event) => {
        if(event.lengthComputable && progress) progress(event);
    });
    xhr.addEventListener("loadend", (event) => {
        if(complete) complete({event, request: xhr});
    });
    xhr.send(data);
};

export const hydrate = (referrer, maxAge = 60) => {
    if(!referrer) return;
    cSet("referrer_code", (referrer.code ? referrer.code : undefined), maxAge);
    cSet("referrer_name", (referrer.fullname ? referrer.fullname : undefined), maxAge);
    cSet("referrer_email", (referrer.email ? referrer.email : undefined), maxAge);
    cSet("referrer_type", (referrer.type ? referrer.type : undefined), maxAge);
    const expiration = new Date();
    expiration.setTime(expiration.getTime() + (maxAge * 24 * 3600 * 1000));
    cSet("cookie_expiration", expiration.getTime(), maxAge);
};

export const set = (name, value, validity) => {
    cSet(name, value, validity);
};

export const get = () => {
    return {
        code: cGet("referrer_code", undefined),
        name: cGet("referrer_name", undefined),
        email: cGet("referrer_email", undefined),
        type: cGet("referrer_type", undefined),
        expiration: cGet("cookie_expiration", undefined)
    };
};

export const unset = () => {
    cSet("referrer_code", undefined, -1);
    cSet("referrer_name", undefined, -1);
    cSet("referrer_email", undefined, -1);
    cSet("referrer_type", undefined, -1);
    cSet("cookie_expiration", undefined, -1);
};

const cSet = (name, value, validity) => {
    const options = {
        path: "/",
        // secure: true,
        samesite: 'strict',
        "max-age": validity * 24 * 3600
    };
    let cookieString = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    Object.entries(options).forEach(([key, val]) => {
        cookieString += `; ${key}`;
        if(val !== true) cookieString += `=${val}`;
    });
    document.cookie = cookieString;
};

const cGet = (name, defaultValue = undefined) => {
    let matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );

    return matches ? decodeURIComponent(matches[1]) : defaultValue;
};
